import React, { useContext, useEffect, useState } from "react"; // eslint-disable-line no-unused-vars
import { AppContext } from "../context/app.context";
import { ModelTsContext } from "../context/modelTS.context";
import { ScheduleContext } from "../context/schedule.context";
import Checkbox from "./Checkbox";
import { FILTERS_SURFACE_ARRAY } from "../utility/keys";
import Input from "./Input";
import search from "./../assets/icons/search.svg";
import JobTile from "../screens/schedule/JobTile";

const UnassignedProjects = () => {
  const {
    currentFilters,
    onSurfaceFiltersChanged,
    setOpenJobsDetailModal,
    largeView,
    setLargeView,
  } = useContext(AppContext);
  const { myJsonArraySort } = useContext(ModelTsContext);
  const {
    scheduleArray,
    setDragObject,
    setDragObjectInvoiceNo,
    setDropObject,
    schedulePreparing,
    selectedUnscheduledJob,
    setSelectedUnscheduledJob,
    // Job Parking
    parkedJobs,
    parkJob,
    unparkJob,
    dragObject,
    // Auto-expand Suppressed accordion
    autoExpandSuppressed,
    setAutoExpandSuppressed,
  } = useContext(ScheduleContext);
  const [hideFilter, setHideFilter] = useState(true);
  const [hideSuppressed, setHideSuppressed] = useState(true);
  const [suppressedArray, setSuppressedArray] = useState([]);
  const [isDragOverPark, setIsDragOverPark] = useState(false);
  const [isDragOverRTS, setIsDragOverRTS] = useState(false);
  const [isDragOverCreatedVerified, setIsDragOverCreatedVerified] = useState(false);
  const [hideParked, setHideParked] = useState(false); // Default expanded when items exist
  const [hideRTS, setHideRTS] = useState(false); // Default expanded
  const [hideCreatedVerified, setHideCreatedVerified] = useState(true);
  const [createdVerifiedArray, setCreatedVerifiedArray] = useState([]);

  const [query, setQuery] = useState("");
  const [scheduleProjects, setScheduleProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(
    selectedUnscheduledJob
  );

  // - - - - - - - - - -

  // Auto-expand Suppressed accordion when a job is suppressed
  useEffect(() => {
    if (autoExpandSuppressed) {
      setHideSuppressed(false);
      setAutoExpandSuppressed(false);
    }
  }, [autoExpandSuppressed, setAutoExpandSuppressed]);

  // - - - - - - - - - -

  const onProjectDetailClick = (project) => {
    setOpenJobsDetailModal({ show: true, jobsDetail: [project] });
    console.log("UnassignedProjects onProjectDetailClick, project: ", project);
  };

  // - - - - - - - - - -

  const onProjectSelect = (project) => {
    setScheduleProjects(() =>
      scheduleProjects.map((_project) => {
        if (_project.id === project.id) {
          if (_project.selected) {
            setSelectedProject(null);
          } else {
            setSelectedProject(_project);
          }
        }
        return {
          ..._project,
          selected: _project.id === project.id ? !_project.selected : false,
        };
      })
    );
    console.log(
      "UnassignedProjects onProjectSelect, project: ",
      project,
      ", selected: ",
      !project.selected
    );
  };

  // - - - - - - - - - -

  const allowDropHere = (event) => {
    event.preventDefault();
    console.log("UnassignedProjects allowDropHere...");
  };

  // - - - - - - - - - -

  const onDragStarted = (id, invoiceNo) => {
    // event.dataTransfer.setData("div", event.target.id);
    setDragObject(id);
    // Store invoiceNo for tanstackOnly fallback - this comes directly from the UI item being dragged
    setDragObjectInvoiceNo(invoiceNo);
    console.log("UnassignedProjects dragStarted id:", id, ", invoiceNo:", invoiceNo);
  };

  // - - - - - - - - - -

  const hasBeenDropped = (event, id) => {
    event.preventDefault();
    const droppedObject = { id: id };
    setDropObject(droppedObject);
    console.log("UnassignedProjects hasBeenDropped id: ", id);
  };

  // - - - - - - - - - -

  /**
   * Handles dropping a job onto the Parked zone.
   * Only scheduled/assigned jobs (in the grid) can be parked.
   */
  const handleParkDrop = (event) => {
    event.preventDefault();
    setIsDragOverPark(false);

    // dragObject is the job ID being dragged
    if (!dragObject) {
      console.log("UnassignedProjects handleParkDrop: No dragObject");
      return;
    }

    // Find the job in scheduleArray
    const job = scheduleArray.find((j) => j.id === dragObject);
    if (!job) {
      console.log("UnassignedProjects handleParkDrop: Job not found", dragObject);
      return;
    }

    // Only allow parking jobs that are scheduled (have date_scheduled or status 4)
    // Reject RTS (status 3) and Suppressed (status 3.1) jobs
    const statusCode = parseFloat(job.statusCode);
    if (job.start === "" || statusCode === 3 || statusCode === 3.1) {
      console.log("UnassignedProjects handleParkDrop: Cannot park RTS/Suppressed job", job.invoiceNo);
      return;
    }

    // Park the job
    parkJob(job.id, job.invoiceNo, job.installer, job.start);
    setDragObject(""); // Clear the drag state
    console.log("UnassignedProjects handleParkDrop: Parked job", job.invoiceNo);
  };

  // - - - - - - - - - -

  const onSearch = () => {
    console.log("UnassignedProjects onSearch:", query);
  };

  // - - - - - - - - - -

  // 2025-08-25 - Note: it would appear that we have these render function names backwards
  //                    this one actually renders the queried cells
  const renderStandardCells = () => {
    return scheduleProjects
      .filter((project) => {
        // filter query by: invoiceNo, projectNo, phoneNo, firstName, lastName
        const queryLength = query.length;
        const querySlice = query.toLowerCase().slice(0, queryLength);
        const invoiceNoSlice = project.invoiceNo
          ?.toString()
          .slice(0, queryLength);
        const projectNoSlice = project.projectNo?.slice(0, queryLength);
        const phoneNoSlice = project.cellPhone?.slice(0, queryLength);
        const projectFirstnameSlice = project.firstName
          ?.toLowerCase()
          .slice(0, queryLength);
        const projectLastnameSlice = project.lastName
          ?.toLowerCase()
          .slice(0, queryLength);
        return (
          project.start === "" &&
          parseFloat(project.statusCode) === 3 &&
          (querySlice === projectLastnameSlice ||
            querySlice === projectFirstnameSlice ||
            querySlice === invoiceNoSlice ||
            querySlice === projectNoSlice ||
            querySlice === phoneNoSlice)
        );
      })
      .map((project, index) => (
        <JobTile
          key={index}
          projectDetailClick={() => onProjectDetailClick(project)}
          //dragStarted={() => setDragObject(project.id)}
          dragStarted={onDragStarted}
          project={project}
          className="bg-skin-primary mb-2 last:mb-0"
          largeView={largeView}
        ></JobTile>
      ));
  };

  // - - - - - - - - - -

  // 2025-08-25 - Note: it would appear that we have these render function names backwards
  //                    this one actually renders the standard, non-queried cells
  const renderQueriedCells = () => {
    // 2025-08-25 - JIRA SW-867 show Overdues at top of RTS list
    //              added field "date_due" and use it here to sort to the top
    //              used Copilot AI to create visual indicator (white leftside border in front of surface)
    const filteredQueriedCells = scheduleProjects.filter(
      (project) =>
        project.start === "" &&
        parseFloat(project.statusCode) === 3
    );
    // console.log(
    //   "UnassignedProjects renderQueriedCells, filteredQueriedCells: ",
    //   filteredQueriedCells
    // );
    const sortedQueriedCells = myJsonArraySort(
      filteredQueriedCells,
      "dateDue",
      "String/Text",
      "descending"
    );
    const mappedQueriedCells = sortedQueriedCells.map((project, index) => (
      <JobTile
        key={index}
        projectDetailClick={() => onProjectDetailClick(project)}
        selectable={true}
        projectSelect={() => onProjectSelect(project)}
        //dragStarted={() => setDragObject(project.id)}
        dragStarted={onDragStarted}
        project={{
          ...project,
          // Add a new prop for visual indication
          dateDueBadge:
            project.dateDue && project.dateDue !== "" ? true : false,
        }}
        className={`bg-skin-primary mb-2 last:mb-0 ${
          project.dateDue && project.dateDue !== ""
            ? "border-l-4 border-yellow-400"
            : ""
        }`}
        largeView={largeView}
      ></JobTile>
    ));

    return mappedQueriedCells;
  };

  // - - - - - - - - - - - - - - - - -  EFFECT HOOKS  - - - - - - - - - - - - - - - - - -
  //
  // largeView
  // scheduleProjects, query
  // selectedProject
  // scheduleArray
  //

  useEffect(() => {
    localStorage.setItem("largeView", JSON.stringify(largeView));
  }, [largeView]);

  // - - - - - - - - - -

  useEffect(() => {
    setSuppressedArray(
      query !== ""
        ? scheduleProjects.filter((project) => {
            // filter query by: invoiceNo, projectNo, phoneNo, firstName, lastName
            const queryLength = query.length;
            const querySlice = query.toLowerCase().slice(0, queryLength);
            const invoiceNoSlice = project.invoiceNo
              ?.toString()
              .slice(0, queryLength);
            const projectNoSlice = project.projectNo?.slice(0, queryLength);
            const phoneNoSlice = project.cellPhone?.slice(0, queryLength);
            const projectFirstnameSlice = project.firstName
              ?.toLowerCase()
              .slice(0, queryLength);
            const projectLastnameSlice = project.lastName
              ?.toLowerCase()
              .slice(0, queryLength);
            return (
              project.start === "" &&
              parseFloat(project.statusCode) === 3.1 &&
              (querySlice === projectLastnameSlice ||
                querySlice === projectFirstnameSlice ||
                querySlice === invoiceNoSlice ||
                querySlice === projectNoSlice ||
                querySlice === phoneNoSlice)
            );
          })
        : scheduleProjects.filter(
            (job) => job.start === "" && job.statusCode === 3.1
          )
    );
  }, [scheduleProjects, query]);

  // - - - - - - - - - -

  useEffect(() => {
    const isCreatedOrVerified = (sc) => {
      const code = parseFloat(sc);
      return code > 0 && code < 3; // includes sub-statuses: 1.1-1.7, 2.1, etc. (#82)
    };
    setCreatedVerifiedArray(
      query !== ""
        ? scheduleProjects.filter((project) => {
            const queryLength = query.length;
            const querySlice = query.toLowerCase().slice(0, queryLength);
            const invoiceNoSlice = project.invoiceNo
              ?.toString()
              .slice(0, queryLength);
            const projectNoSlice = project.projectNo?.slice(0, queryLength);
            const phoneNoSlice = project.cellPhone?.slice(0, queryLength);
            const projectFirstnameSlice = project.firstName
              ?.toLowerCase()
              .slice(0, queryLength);
            const projectLastnameSlice = project.lastName
              ?.toLowerCase()
              .slice(0, queryLength);
            return (
              project.start === "" &&
              isCreatedOrVerified(project.statusCode) &&
              (querySlice === projectLastnameSlice ||
                querySlice === projectFirstnameSlice ||
                querySlice === invoiceNoSlice ||
                querySlice === projectNoSlice ||
                querySlice === phoneNoSlice)
            );
          })
        : scheduleProjects.filter(
            (job) => job.start === "" && isCreatedOrVerified(job.statusCode)
          )
    );
  }, [scheduleProjects, query]);

  // - - - - - - - - - -

  useEffect(() => {
    setSelectedUnscheduledJob(selectedProject);
    console.log(
      "UnassignedProjects useEffect[selectedProject], selectedProject: ",
      selectedProject
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProject]);

  // - - - - - - - - - -

  useEffect(() => {
    setScheduleProjects(scheduleArray);
  }, [scheduleArray]);

  // Compute RTS count for accordion header
  const rtsCount = scheduleProjects.filter(
    (p) => p.start === "" && parseFloat(p.statusCode) === 3
  ).length;

  // Only count/show parked jobs that still exist in scheduleArray (guards against stale localStorage entries)
  const validParkedJobs = parkedJobs.filter((pj) => scheduleArray.some((j) => j.id === pj.id));

  return (
    <section className="flex flex-col bg-skin-unassigned px-4 h-full">
      <div className="h-[4.5rem] flex items-center gap-2">
        <button onClick={() => setHideFilter(!hideFilter)}>
          {hideFilter ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className="fill-skin-base"
            >
              <g clipPath="url(#clip0_1_539)">
                <path d="M6.99999 6H17L11.99 12.3L6.99999 6ZM4.24999 5.61C6.26999 8.2 9.99999 13 9.99999 13V19C9.99999 19.55 10.45 20 11 20H13C13.55 20 14 19.55 14 19V13C14 13 17.72 8.2 19.74 5.61C20.25 4.95 19.78 4 18.95 4H5.03999C4.20999 4 3.73999 4.95 4.24999 5.61Z" />
              </g>
              <defs>
                <clipPath id="clip0_1_539">
                  <rect width="24" height="24" />
                </clipPath>
              </defs>
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className="fill-skin-base"
            >
              <mask
                id="mask0_21_2701"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
              >
                <rect width="24" height="24" />
              </mask>
              <g mask="url(#mask0_21_2701)">
                <path d="M14.7999 11.975L13.3749 10.55L16.9499 6H8.8249L6.8249 4H18.9999C19.4166 4 19.7166 4.18334 19.8999 4.55C20.0832 4.91667 20.0499 5.26667 19.7999 5.6L14.7999 11.975ZM19.7749 22.6L13.9999 16.825V19C13.9999 19.2833 13.9041 19.5208 13.7124 19.7125C13.5207 19.9042 13.2832 20 12.9999 20H10.9999C10.7166 20 10.4791 19.9042 10.2874 19.7125C10.0957 19.5208 9.9999 19.2833 9.9999 19V12.825L1.3999 4.225L2.7999 2.8L21.1999 21.2L19.7749 22.6Z" />
              </g>
            </svg>
          )}
        </button>
        <button onClick={() => setLargeView(!largeView)}>
          {largeView ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              className="fill-skin-base"
            >
              <path d="M5.24999 1.96875V4.78125C5.24999 5.24725 4.87223 5.625 4.40624 5.625H0.84375C0.377754 5.625 0 5.24725 0 4.78125V1.96875C0 1.50275 0.377754 1.125 0.84375 1.125H4.40624C4.87223 1.125 5.24999 1.50275 5.24999 1.96875ZM11.625 10.4062V7.59375C11.625 7.12775 11.2473 6.75 10.7813 6.75H7.21874C6.75274 6.75 6.37499 7.12775 6.37499 7.59375V10.4062C6.37499 10.8722 6.75274 11.25 7.21874 11.25H10.7812C11.2473 11.25 11.625 10.8722 11.625 10.4062ZM12.75 1.96875V4.78125C12.75 5.24725 13.1278 5.625 13.5938 5.625H17.1562C17.6222 5.625 18 5.24725 18 4.78125V1.96875C18 1.50275 17.6222 1.125 17.1562 1.125H13.5938C13.1278 1.125 12.75 1.50275 12.75 1.96875ZM11.625 4.78125V1.96875C11.625 1.50275 11.2473 1.125 10.7813 1.125H7.21874C6.75274 1.125 6.37499 1.50275 6.37499 1.96875V4.78125C6.37499 5.24725 6.75274 5.625 7.21874 5.625H10.7812C11.2473 5.625 11.625 5.24725 11.625 4.78125ZM4.40624 6.75H0.84375C0.377754 6.75 0 7.12775 0 7.59375V10.4062C0 10.8722 0.377754 11.25 0.84375 11.25H4.40624C4.87223 11.25 5.24999 10.8722 5.24999 10.4062V7.59375C5.24999 7.12775 4.87223 6.75 4.40624 6.75ZM0 13.2188V16.0312C0 16.4972 0.377754 16.875 0.84375 16.875H4.40624C4.87223 16.875 5.24999 16.4972 5.24999 16.0312V13.2188C5.24999 12.7528 4.87223 12.375 4.40624 12.375H0.84375C0.377754 12.375 0 12.7528 0 13.2188ZM13.5938 11.25H17.1562C17.6222 11.25 18 10.8722 18 10.4062V7.59375C18 7.12775 17.6222 6.75 17.1562 6.75H13.5938C13.1278 6.75 12.75 7.12775 12.75 7.59375V10.4062C12.75 10.8722 13.1278 11.25 13.5938 11.25ZM13.5938 16.875H17.1562C17.6222 16.875 18 16.4972 18 16.0312V13.2188C18 12.7528 17.6222 12.375 17.1562 12.375H13.5938C13.1278 12.375 12.75 12.7528 12.75 13.2188V16.0312C12.75 16.4972 13.1278 16.875 13.5938 16.875ZM6.37499 13.2188V16.0312C6.37499 16.4972 6.75274 16.875 7.21874 16.875H10.7812C11.2472 16.875 11.625 16.4972 11.625 16.0312V13.2188C11.625 12.7528 11.2472 12.375 10.7812 12.375H7.21874C6.75274 12.375 6.37499 12.7528 6.37499 13.2188Z" />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="16"
              viewBox="0 0 18 16"
              className="fill-skin-base"
            >
              <path d="M10.4062 0.125H17.1562C17.6222 0.125 18 0.502754 18 0.96875V6.59375C18 7.05975 17.6222 7.4375 17.1562 7.4375H10.4062C9.94025 7.4375 9.5625 7.05975 9.5625 6.59375V0.96875C9.5625 0.502754 9.94025 0.125 10.4062 0.125ZM7.59375 0.125H0.84375C0.377754 0.125 0 0.502754 0 0.96875V6.59375C0 7.05975 0.377754 7.4375 0.84375 7.4375H7.59375C8.05975 7.4375 8.4375 7.05975 8.4375 6.59375V0.96875C8.4375 0.502754 8.05975 0.125 7.59375 0.125ZM0 9.40625V15.0313C0 15.4972 0.377754 15.875 0.84375 15.875H7.59375C8.05975 15.875 8.4375 15.4972 8.4375 15.0313V9.40625C8.4375 8.94025 8.05975 8.5625 7.59375 8.5625H0.84375C0.377754 8.5625 0 8.94025 0 9.40625ZM10.4062 15.875H17.1562C17.6222 15.875 18 15.4972 18 15.0313V9.40625C18 8.94025 17.6222 8.5625 17.1562 8.5625H10.4062C9.94025 8.5625 9.5625 8.94025 9.5625 9.40625V15.0313C9.5625 15.4972 9.94025 15.875 10.4062 15.875Z" />
            </svg>
          )}
        </button>
        <div className="flex-1 h-8">
          <Input
            placeholder="Quick Search"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onEnter={() => onSearch()}
            className="bg-yellow-30 text-black"
          >
            <Input.Suffix>
              <button className="w-6" onClick={() => onSearch()}>
                <img src={search} alt="search" />
              </button>
            </Input.Suffix>
          </Input>
        </div>
      </div>

      <div className={`${hideFilter ? "hidden" : ""} pb-8`}>
        {FILTERS_SURFACE_ARRAY.map(({ name }, index) => (
          <div key={index} className="mb-2 last:mb-0 flex">
            <div
              className={`bg-surface-${name?.split(" ").join("-")} badge mr-2 `}
            ></div>
            <Checkbox
              label={name}
              disabled={schedulePreparing}
              value={currentFilters.surfaceFilters[index]}
              onChange={() => onSurfaceFiltersChanged(index)}
            />
          </div>
        ))}
      </div>

      {/* PARKED SECTION - collapsible like Suppressed */}
      <div
        className="mb-2 border-2 border-dashed rounded transition-colors"
        style={{
          borderColor: isDragOverPark ? "#60a5fa" : "#fdba74", // blue on drag, orange-300 at rest
          backgroundColor: isDragOverPark ? "rgba(96, 165, 250, 0.1)" : "transparent",
        }}
        onDragOver={(e) => {
          e.preventDefault();
          setIsDragOverPark(true);
        }}
        onDragLeave={() => setIsDragOverPark(false)}
        onDrop={handleParkDrop}
      >
        <button
          className="py-2 px-2 flex gap-2 items-center w-full"
          onClick={() => setHideParked(!hideParked)}
        >
          {/* Parking icon - orange to match theme */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            style={{ fill: "#f97316" }} // orange-500
          >
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2c1.1 0 2 .9 2 2v2c0 1.1-.9 2-2 2h-1v3h-2V7h1zm1 4h1V9h-1v2z"/>
          </svg>
          <span className="font-bold flex-1 text-left" style={{ color: "#ea580c" }}> {/* orange-600 */}
            Parked ({validParkedJobs.length})
          </span>
          {hideParked ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              style={{ fill: "#f97316" }} // orange-500
            >
              <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              style={{ fill: "#f97316" }} // orange-500
            >
              <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z" />
            </svg>
          )}
        </button>
        {/* PARKED JOBS LIST - only show when jobs exist and not hidden */}
        {validParkedJobs.length > 0 && (
          <div
            className={`${
              hideParked ? "h-0 overflow-hidden" : "max-h-48 overflow-auto"
            } transition-all duration-200 px-2 pb-2`}
          >
            {parkedJobs.map((pj) => {
              const fullJob = scheduleArray.find((j) => j.id === pj.id);
              return fullJob ? (
                <div key={pj.id} className="relative mb-2 last:mb-0">
                  <JobTile
                    project={fullJob}
                    projectDetailClick={() => onProjectDetailClick(fullJob)}
                    dragStarted={onDragStarted}
                    draggable={true}
                    className="bg-skin-primary pr-8"
                    style={{ borderLeft: "4px solid #fb923c" }} // orange-400
                    largeView={largeView}
                  />
                  <button
                    className="absolute top-1 right-1 w-5 h-5 flex items-center justify-center
                               text-orange-600 hover:text-red-600 hover:bg-red-100 rounded-full
                               transition-colors text-xs font-bold"
                    title="Unpark job"
                    onClick={() => {
                      if (window.confirm(`Unpark job for ${fullJob.lastName || fullJob.invoiceNo}?`)) {
                        unparkJob(pj.id);
                      }
                    }}
                  >
                    ✕
                  </button>
                </div>
              ) : null;
            })}
          </div>
        )}
      </div>

      {/* RTS SECTION - collapsible accordion */}
      <div
        className={`${hideRTS ? "" : "flex-1"} flex flex-col min-h-0 overflow-hidden`}
        style={
          isDragOverRTS
            ? { border: "2px dashed #60a5fa", backgroundColor: "rgba(96, 165, 250, 0.1)", borderRadius: "4px" }
            : {}
        }
        onDragOver={(e) => {
          allowDropHere(e);
          setIsDragOverRTS(true);
        }}
        onDragLeave={() => setIsDragOverRTS(false)}
        onDrop={(e) => {
          setIsDragOverRTS(false);
          hasBeenDropped(e, "Unassigned_RTS");
        }}
      >
        <button
          className="py-2 flex gap-2 items-center"
          onClick={() => setHideRTS(!hideRTS)}
        >
          <span className="font-bold flex-1 text-left">
            RTS ({rtsCount})
          </span>
          {hideRTS ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className="fill-skin-primary"
            >
              <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className="fill-skin-primary"
            >
              <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z" />
            </svg>
          )}
        </button>
        <div
          className={`${
            hideRTS ? "h-0 overflow-hidden" : "flex-1 overflow-auto"
          } transition-all duration-200`}
        >
          {query !== "" ? renderStandardCells() : renderQueriedCells()}
        </div>
      </div>
      {/* SUPPRESSED SECTION */}
      <div className={`${hideSuppressed ? "" : "flex-1"} flex flex-col min-h-0 overflow-hidden`}>
        <button
          className="py-2 flex gap-2 items-center"
          onClick={() => setHideSuppressed(!hideSuppressed)}
        >
          <span className="font-bold flex-1 text-left">
            Suppressed ({suppressedArray?.length})
          </span>
          {hideSuppressed ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className="fill-skin-primary"
            >
              <g clipPath="url(#clip0_909_991)">
                <path d="M7.41 8.58997L12 13.17L16.59 8.58997L18 9.99997L12 16L6 9.99997L7.41 8.58997Z" />
              </g>
              <defs>
                <clipPath id="clip0_909_991">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className="fill-skin-primary"
            >
              <g clipPath="url(#clip0_907_963)">
                <path d="M7.41 15.41L12 10.83L16.59 15.41L18 14L12 8.00003L6 14L7.41 15.41Z" />
              </g>
              <defs>
                <clipPath id="clip0_907_963">
                  <rect
                    width="24"
                    height="24"
                    fill="white"
                    transform="matrix(1 0 0 -1 0 24)"
                  />
                </clipPath>
              </defs>
            </svg>
          )}
        </button>
        <div
          className={`${
            hideSuppressed ? "h-0 overflow-hidden" : "flex-1 overflow-auto"
          } transition-all duration-200`}
        >
          {suppressedArray.map((project, index) => (
            <JobTile
              key={index}
              projectDetailClick={() => onProjectDetailClick(project)}
              dragStarted={() => onDragStarted(project.id, project.invoiceNo)}
              project={project}
              className="bg-skin-primary mb-2 last:mb-0 opacity-50"
              largeView={largeView}
            ></JobTile>
          ))}
        </div>
      </div>

      {/* CREATED/VERIFIED SECTION - statusCode 1 & 2 */}
      <div
        className={`${hideCreatedVerified ? "" : "flex-1"} flex flex-col min-h-0 overflow-hidden`}
        style={
          isDragOverCreatedVerified
            ? { border: "2px dashed #60a5fa", backgroundColor: "rgba(96, 165, 250, 0.1)", borderRadius: "4px" }
            : {}
        }
        onDragOver={(e) => {
          allowDropHere(e);
          setIsDragOverCreatedVerified(true);
        }}
        onDragLeave={() => setIsDragOverCreatedVerified(false)}
        onDrop={(e) => {
          setIsDragOverCreatedVerified(false);
          hasBeenDropped(e, "Unassigned_RTS");
        }}
      >
        <button
          className="py-2 flex gap-2 items-center"
          onClick={() => setHideCreatedVerified(!hideCreatedVerified)}
        >
          <span className="font-bold flex-1 text-left">
            Created/Verified ({createdVerifiedArray?.length})
          </span>
          {hideCreatedVerified ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className="fill-skin-primary"
            >
              <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              className="fill-skin-primary"
            >
              <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z" />
            </svg>
          )}
        </button>
        <div
          className={`${
            hideCreatedVerified ? "h-0 overflow-hidden" : "flex-1 overflow-auto"
          } transition-all duration-200`}
        >
          {createdVerifiedArray.map((project, index) => (
            <JobTile
              key={index}
              projectDetailClick={() => onProjectDetailClick(project)}
              dragStarted={() => onDragStarted(project.id, project.invoiceNo)}
              project={project}
              className="bg-skin-primary mb-2 last:mb-0 opacity-70"
              largeView={largeView}
            ></JobTile>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UnassignedProjects;
